module.exports = __webpack_public_path__ + "img/Pag1_2.0eef010c.png";